<template>
  <vue-page-transition name="fade-in-down">
    <v-content class="db-content">
      <v-container fluid grid-list-xl class="useroptions">
        <sequential-entrance fromTop>
          <v-layout row wrap>
            <v-flex xs12 sm12 lg12 x12 class="lg5-custom">
              <v-card class="user-ui" style="padding: 15px">
                <v-avatar size="50px" tile>
                  <img alt="Avatar" :src="userInfo.Fs.wI" />
                </v-avatar>
                <label class="headline" style="margin-left: 20px">
                  {{ userInfo.Fs.sd }}
                </label>

                <button class="callouts" style="margin-left: 40px">
                  <strong>4 pending decision's</strong> that have
                  <span id="timer"></span>
                </button>

                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  elevation="10"
                  :max-width="300"
                  min-height="130"
                >
                  <template v-slot:activator="{ off }">
                    <div v-on="on" class="three-dot">
                      <v-toolbar-title>Dashboard</v-toolbar-title>
                      <v-spacer />
                    </div>
                  </template>
                </v-menu>
              </v-card>
            </v-flex>
          </v-layout>
        </sequential-entrance>

        <!-- <v-flex class="space1" />

              <sequential-entrance fromBottom>
                 <div class="callouts">
                   <OnSiteTimer :threshold="30" v-slot:default="slotData">
                     <TimeOnSiteCallout title="Friendly notice ⏲" :timeOnSite="slotData.timeOnSite" />
                   </OnSiteTimer>
                 </div>
              </sequential-entrance>-->

        <v-flex class="space1" />

        <sequential-entrance fromTop>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 xl12 class="lg5-custom">
              <div style="text-align: center; background: opacity=.1">
                <template v-for="(item, index) in icons">
                  <v-card
                    :key="index"
                    width="70"
                    height="50"
                    class="menu-icon"
                    @click="showCard(item.text)"
                  >
                    <v-icon v-text="item.icon" class="icons"></v-icon>
                  </v-card>
                </template>
              </div>
            </v-flex>
          </v-layout>
        </sequential-entrance>

        <v-flex class="space2" />

        <sequential-entrance delay="3000">
          <div class="team">
            <v-container>
              <v-layout row wrap>
                <v-flex sm6 xs12 md6 lg3>
                  <v-card class="theme-bg-card">
                    <v-list-item>
                      <sequential-entrance delay="500" fromBottom>
                        <v-list-item-content>
                          <sequential-entrance delay="3000">
                            <main class="flexbox">
                              <Board id="board-1">
                                <Card id="card-1" draggable="true">
                                  <sequential-entrance delay="500" fromBottom>
                                    <v-list-item-content>
                                      <v-flex class="space3"></v-flex>
                                      <div
                                        class="overline text-center"
                                        style="color: #11ece5"
                                      >
                                        <h2>MARKETING</h2>
                                      </div>
                                      <v-list-item-title
                                        class="headline mb-1 text-center"
                                        style="color: #78b59c"
                                      >
                                        <h2>82%</h2></v-list-item-title
                                      >
                                      <v-card-actions>
                                        <MarketingProgressBar
                                          class="m-center"
                                        />
                                      </v-card-actions>

                                      <div><v-divider></v-divider></div>
                                      <v-flex class="space3"></v-flex>

                                      <v-container class="data-tiles">
                                        <v-row justify="space-around">
                                          <v-column>
                                            <div
                                              class="overline text-center"
                                              style="color: #fff"
                                            >
                                              Calls
                                            </div>
                                            <v-list-item-title
                                              class="headline mb-1 text-center"
                                              style="color: #78b59c"
                                              >1,428</v-list-item-title
                                            >
                                          </v-column>
                                          <v-column>
                                            <div
                                              class="overline text-center"
                                              style="color: #fff"
                                            >
                                              Emails
                                            </div>
                                            <v-list-item-title
                                              class="headline mb-1 text-center"
                                              style="color: #78b59c"
                                              >168</v-list-item-title
                                            >
                                          </v-column>
                                        </v-row>
                                      </v-container>
                                    </v-list-item-content>
                                  </sequential-entrance>
                                </Card>
                              </Board>
                            </main>
                          </sequential-entrance>
                        </v-list-item-content>
                      </sequential-entrance>
                    </v-list-item>
                  </v-card>
                </v-flex>

                <v-flex sm6 xs12 md6 lg3>
                  <v-card class="theme-bg-card">
                    <v-list-item>
                      <sequential-entrance delay="1500" fromBottom>
                        <v-list-item-content>
                          <main class="flexbox">
                            <Board id="board-2">
                              <Card id="card-2" draggable="true">
                                <sequential-entrance delay="1000" fromBottom>
                                  <v-list-item-content>
                                    <v-flex class="space3"></v-flex>
                                    <div
                                      class="overline text-center"
                                      style="color: #11ece5"
                                    >
                                      <h2>SALES</h2>
                                    </div>
                                    <v-list-item-title
                                      class="headline mb-1 text-center"
                                      style="color: #eeec24"
                                    >
                                      <h2>72%</h2></v-list-item-title
                                    >

                                    <v-card-actions>
                                      <SalesProgressBar class="m-center" />
                                    </v-card-actions>

                                    <div><v-divider></v-divider></div>
                                    <v-flex class="space3"></v-flex>

                                    <v-container class="data-tiles">
                                      <v-row justify="space-around">
                                        <v-column>
                                          <div
                                            class="overline text-center"
                                            style="color: #fff"
                                          >
                                            Quotes
                                          </div>
                                          <v-list-item-title
                                            class="headline mb-1 text-center"
                                            style="color: #78b59c"
                                            >25</v-list-item-title
                                          >
                                        </v-column>
                                        <v-column>
                                          <div
                                            class="overline text-center"
                                            style="color: #fff"
                                          >
                                            Sales
                                          </div>
                                          <v-list-item-title
                                            class="headline mb-1 text-center"
                                            style="color: #78b59c"
                                            >6 | $18,452</v-list-item-title
                                          >
                                        </v-column>
                                      </v-row>
                                    </v-container>
                                  </v-list-item-content>
                                </sequential-entrance>
                              </Card>
                            </Board>
                          </main>
                        </v-list-item-content>
                      </sequential-entrance>
                    </v-list-item>
                  </v-card>
                </v-flex>

                <v-flex sm6 xs12 md6 lg3>
                  <v-card class="theme-bg-card">
                    <v-list-item>
                      <sequential-entrance delay="1500" fromBottom>
                        <v-list-item-content>
                          <main class="flexbox">
                            <Board id="board-3">
                              <Card id="card-3" draggable="true">
                                <sequential-entrance delay="1500" fromBottom>
                                  <v-list-item-content>
                                    <v-flex class="space3"></v-flex>
                                    <div
                                      class="overline text-center"
                                      style="color: #11ece5"
                                    >
                                      <h2>PROJECTS</h2>
                                    </div>
                                    <v-list-item-title
                                      class="headline mb-1 text-center"
                                      style="color: #78b59c"
                                    >
                                      <h2>82%</h2></v-list-item-title
                                    >

                                    <v-card-actions>
                                      <ProjectsProgressBar class="m-center" />
                                    </v-card-actions>

                                    <div><v-divider></v-divider></div>
                                    <v-flex class="space3"></v-flex>

                                    <v-container fluid class="data-tiles">
                                      <v-row justify="space-around">
                                        <v-column>
                                          <div
                                            class="overline text-center"
                                            style="color: #fff"
                                          >
                                            Intakes
                                          </div>
                                          <v-list-item-title
                                            class="headline mb-1 text-center"
                                            style="color: #78b59c"
                                            >10</v-list-item-title
                                          >
                                        </v-column>
                                        <v-column>
                                          <div
                                            class="overline text-center"
                                            style="color: #fff"
                                          >
                                            Pending
                                          </div>
                                          <v-list-item-title
                                            class="headline mb-1 text-center"
                                            style="color: #78b59c"
                                            >3</v-list-item-title
                                          >
                                        </v-column>
                                      </v-row>
                                    </v-container>
                                  </v-list-item-content>
                                </sequential-entrance>
                              </Card>
                            </Board>
                          </main>
                        </v-list-item-content>
                      </sequential-entrance>
                    </v-list-item>
                  </v-card>
                </v-flex>

                <v-flex sm6 xs12 md6 lg3>
                  <v-card class="theme-bg-card">
                    <v-list-item>
                      <sequential-entrance delay="1500" fromBottom>
                        <v-list-item-content>
                          <main class="flexbox">
                            <Board id="board-4">
                              <Card id="card-4" draggable="true">
                                <sequential-entrance delay="2000" fromBottom>
                                  <v-list-item-content>
                                    <v-flex class="space3"></v-flex>
                                    <div
                                      class="overline text-center"
                                      style="color: #11ece5"
                                    >
                                      <h2>ACCOUNTING</h2>
                                    </div>
                                    <v-list-item-title
                                      class="headline mb-1 text-center"
                                      style="color: #ff0000"
                                    >
                                      <h2>66%</h2></v-list-item-title
                                    >

                                    <v-card-actions>
                                      <AccountingProgressBar class="m-center" />
                                    </v-card-actions>

                                    <div><v-divider></v-divider></div>
                                    <v-flex class="space3"></v-flex>

                                    <v-container fluid class="data-tiles">
                                      <v-row justify="space-around">
                                        <v-column>
                                          <div
                                            class="overline text-center"
                                            style="color: #fff"
                                          >
                                            Collected
                                          </div>
                                          <v-list-item-title
                                            class="headline mb-1 text-center"
                                            style="color: #78b59c"
                                            >$184,759</v-list-item-title
                                          >
                                        </v-column>
                                        <v-column>
                                          <div
                                            class="overline text-center"
                                            style="color: #fff"
                                          >
                                            Pending
                                          </div>
                                          <v-list-item-title
                                            class="headline mb-1 text-center"
                                            style="color: #78b59c"
                                            >$34,487</v-list-item-title
                                          >
                                        </v-column>
                                      </v-row>
                                    </v-container>
                                  </v-list-item-content>
                                </sequential-entrance>
                              </Card>
                            </Board>
                          </main>
                        </v-list-item-content>
                      </sequential-entrance>
                    </v-list-item>
                  </v-card>
                </v-flex>

                <!--
       <v-flex
        sm6
        xs12
        md6
        lg3
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >
        <main class="flexbox">

         <Board id="board-5">
           <Card id="card-5" draggable="true">

 <sequential-entrance delay="2000" fromBottom>

      <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#11ece5;"><h2>HR</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 94% </h2></v-list-item-title>

       <v-card-actions>
                 <HRProgressBar class="m-center" />
        </v-card-actions>

        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>

<v-container fluid class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Payroll</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >$28,424</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Staff</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >16</v-list-item-title>
      </v-column>
    </v-row>
</v-container>

      </v-list-item-content>
      </sequential-entrance>

           </Card>
         </Board>
       </main>
      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>
  </v-card>
</v-flex>

       <v-flex
        sm6
        xs12
        md6
        lg2
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >

        <main class="flexbox">
         <Board id="board-6">
           <Card id="card-6" draggable="true">

   <sequential-entrance delay="2500" fromBottom>
      <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>INFRASTRUCTURE</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 88% </h2></v-list-item-title>

       <v-card-actions>
                 <InfrastructureProgressBar class="m-center" />
        </v-card-actions>

        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>

<v-container fluid class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Overhead</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >$64,750</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Profit Margin</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >78%</v-list-item-title>
      </v-column>
    </v-row>
</v-container>
      </v-list-item-content>
      </sequential-entrance>
           </Card>
         </Board>
       </main>
      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>
  </v-card>
      </v-flex> -->
              </v-layout>
            </v-container>
          </div>
        </sequential-entrance>
      </v-container>

      <v-overlay :absolute="absolute" :value="overlay" opacity="0.85">
        <!-- <v-btn text small color="success" @click="showCard = false">X</v-btn> -->
        <v-btn
          class="mx-2 close-btn"
          fab
          dark
          small
          color="#ccc"
          @click="overlay = false"
          >X</v-btn
        >
        <v-layout row wrap v-if="this.productDetails">
          <v-slide-x-transition>
            <v-flex xs24 sm24 md12 x12>
              <img
                src="@/assets/iphone11.png"
                class="product-animate product"
              />
            </v-flex>
          </v-slide-x-transition>
          <v-flex xs12 sm12 md4 x24>
            <v-list-item class="info-animate mb-margin">
              <v-list-item-content>
                <v-list-item-title class="display-1"
                  >iPhone 11 Pro</v-list-item-title
                >
                <v-list-item-subtitle class="headline"
                  >$ 500</v-list-item-subtitle
                >
                <v-list-item-subtitle class="headline"
                  >Available in Amazon</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!this.productDetails">
          <v-flex>
            <Bar
              v-if="this.activeDetails.Report"
              class="product-animate detail-card"
            />
            <LineChart
              v-if="this.activeDetails.Leadsreport"
              class="product-animate detail-card"
            />
            <Settings
              v-if="this.activeDetails.Settings"
              class="product-animate detail-card"
            />
            <DecisionTimer
              v-if="this.activeDetails.DecisionTracker"
              class="product-animate detail-card"
            />
            <LineBar
              v-if="this.activeDetails.Profitsreport"
              class="product-animate detail-card"
            />
            <MarketingProgressBar
              v-if="this.activeDetails.MarketingProgressBar"
              class="product-animate detail-card"
            />
            <SalesProgressBar
              v-if="this.activeDetails.SalesProgressBar"
              class="product-animate detail-card"
            />
            <ProjectsProgressBar
              v-if="this.activeDetails.ProjectsProgressBar"
              class="product-animate detail-card"
            />
            <AccountingProgressBar
              v-if="this.activeDetails.AccountingProgressBar"
              class="product-animate detail-card"
            />
            <HRProgressBar
              v-if="this.activeDetails.HRProgressBar"
              class="product-animate detail-card"
            />
            <InfrastructureProgressBar
              v-if="this.activeDetails.InfrastructureProgressBar"
              class="product-animate detail-card"
            />
            <Mail
              v-if="this.activeDetails.Email"
              class="product-animate detail-card"
            />
            <Task
              v-if="this.activeDetails.Task"
              class="product-animate detail-card"
            />
            <Calendar
              v-if="this.activeDetails.Calendar"
              class="product-animate detail-card"
            />
            <Events
              v-if="this.activeDetails.Events"
              class="product-animate detail-card"
            />
            <AppointmentCalendar
              v-if="this.activeDetails.AppointmentCalendar"
              class="product-animate detail-card"
            />
            <Weather
              v-if="this.activeDetails.Weather"
              class="product-animate detail-card"
            />
            <Map
              v-if="this.activeDetails.Map"
              class="product-animate detail-card"
            />
            <Agenda
              v-if="this.activeDetails.Agenda"
              class="product-animate detail-card"
            />
            <VideoPlayer
              v-if="this.activeDetails.VideoPlayer"
              class="product-animate detail-card"
            />
            <VideoPlayer2
              v-if="this.activeDetails.VideoPlayer2"
              class="product-animate detail-card"
            />
            <VideoPlayer3
              v-if="this.activeDetails.VideoPlayer3"
              class="product-animate detail-card"
            />
            <VideoPlayer4
              v-if="this.activeDetails.VideoPlayer4"
              class="product-animate detail-card"
            />
            <Animation2
              v-if="this.activeDetails.Animation2"
              class="product-animate detail-card"
            />
            <Search
              v-if="this.activeDetails.Search"
              class="product-animate detail-card"
            />
          </v-flex>
        </v-layout>
      </v-overlay>
    </v-content>
  </vue-page-transition>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import VideoPlayer2 from "@/components/VideoPlayer2.vue";
import VideoPlayer3 from "@/components/VideoPlayer3.vue";
import VideoPlayer4 from "@/components/VideoPlayer4.vue";
import Animation2 from "@/components/Animation2.vue";
// import VideoCall from "@/components/VideoCall.vue";
import Settings from "@/components/Settings.vue";
import Board from "@/components/Board.vue";
import Card from "@/components/Card.vue";
import Mail from "@/components/Mail.vue";
import Task from "@/components/Task.vue";
import Bar from "@/components/Bar.vue";
import LineBar from "@/components/LineBar.vue";
import LineChart from "@/components/LineChart.vue";
import MarketingProgressBar from "@/components/MarketingProgressBar.vue";
import SalesProgressBar from "@/components/SalesProgressBar.vue";
import ProjectsProgressBar from "@/components/ProjectsProgressBar.vue";
import AccountingProgressBar from "@/components/AccountingProgressBar.vue";
import HRProgressBar from "@/components/HRProgressBar.vue";
import InfrastructureProgressBar from "@/components/InfrastructureProgressBar.vue";
import Agenda from "@/components/Agenda.vue";
import Calendar from "@/components/Calendar.vue";
import Events from "@/components/Events.vue";
import AppointmentCalendar from "@/components/AppointmentCalendar.vue";
import Weather from "@/components/Weather.vue";
import Map from "@/components/Map.vue";
// import OnSiteTimer from "@/components/OnSiteTimer";
// import TimeOnSiteCallout from "@/components/TimeOnSiteCallout";
import { gmapApi } from "vue2-google-maps";
import Search from "@/components/Search.vue";
// import carousel from "vue-owl-carousel";

export default {
  name: "Dashboard",
  components: {
    VideoPlayer,
    VideoPlayer2,
    VideoPlayer3,
    VideoPlayer4,
    Animation2,
    // VideoCall,
    Card,
    Settings,
    Board,
    Mail,
    Task,
    Bar,
    LineBar,
    LineChart,
    MarketingProgressBar,
    SalesProgressBar,
    ProjectsProgressBar,
    AccountingProgressBar,
    HRProgressBar,
    InfrastructureProgressBar,
    // carousel,
    Calendar,
    Events,
    AppointmentCalendar,
    Weather,
    Map,
    Agenda,
    // OnSiteTimer,
    // TimeOnSiteCallout,
    Search,
  },
  data() {
    return {
      productDetails: true,
      activeDetails: {
        VideoPlayer: false,
        VideoPlayer2: false,
        VideoPlayer3: false,
        VideoPlayer4: false,
        Animation2: false,
        Email: false,
        Task: false,
        Settings: false,
        Report: false,
        Leadsreport: false,
        Profitsreport: false,
        Calendar: false,
        Events: false,
        AppointmentCalendar: false,
        Weather: false,
        Map: false,
        Agenda: false,
        OnSiteTimer: false,
        TimeOnSiteCallout: false,
        VideoCall: false,
        // Search: false,
      },
      absolute: true,
      overlay: false,
      title: "",
      google: gmapApi,
      date: new Date().toDateString(),
      position: "",
      icons: [
        { text: "Calendar", icon: "mdi mdi-calendar-today" },
        { text: "Email", icon: "mdi mdi-email" },
        { text: "Report", icon: "mdi mdi-chart-bar" },
        { text: "Task", icon: "mdi mdi-check-outline" },
        { text: "Weather", icon: "mdi mdi-weather-cloudy" },
        { text: "Bank", icon: "mdi mdi-bank" },
      ],
      item: 1,
      selectedItem: 1,
      menu: false,
      userInfo: {},
      items: [
        { text: "Home", icon: "mdi-home", nav: "home" },
        -{ text: "Dashboard", icon: "mdi-view-dashboard", nav: "dashboard" },
        { text: "Agenda", icon: "mdi-view-agenda", nav: "dailyagenda" },
        { text: "Training", icon: "mdi-cube-outline", nav: "training" },
        { text: "Sales", icon: "mdi-account", nav: "salesdepartment" },
        {
          text: "Appointments",
          icon: "mdi-calendar-text",
          nav: "appointments",
        },
        { text: "Forms", icon: "mdi-account-edit", nav: "forms" },
        {
          text: "Sentimental Analysis",
          icon: "mdi-clock",
          nav: "sentimental-analysis",
        },
        { text: "Help", icon: "mdi-help", nav: "help" },
        { text: "Logout", icon: "mdi-flag", nav: "login" },
      ],
    };
  },
  methods: {
    next: () => {
      this.$refs.slick.next();
    },
    prev: () => {
      this.$refs.slick.prev();
    },
    reInit: () => {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick();
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      speech.onend = function () {
        Event.$emit("speakModeOn");
      };
      // this.alert = "true";
    },
    handleAuthClick(event) {
      console.log(event);
      window.gapi.auth2.getAuthInstance().signIn();
    },
    handleSignoutClick(event) {
      console.log(event);
      window.gapi.auth2.getAuthInstance().signOut();
    },
    updateSigninStatus(isSignedIn) {
      if (isSignedIn) {
        //With Google
        console.log("Logged In");
        this.listMessages();
        this.unreadMail();
      } else {
        console.log("Logged out");
      }
    },
    initClient() {
      window.gapi.client
        .init({
          apiKey: "AIzaSyCwSEFovFNJ9L_47CuTBIGGJ4qntTOJmrM",
          clientId:
            "292320827989-nou250q4tjpk0j0h4j5poodgai5km88f.apps.googleusercontent.com",
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest",
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
          ],
          scope: [
            "https://mail.google.com/",
            "https://www.googleapis.com/auth/calendar.readonly",
          ],
        })
        .then(
          () => {
            window.gapi.auth2
              .getAuthInstance()
              .isSignedIn.listen(this.updateSigninStatus);
            this.updateSigninStatus(
              window.gapi.auth2.getAuthInstance().isSignedIn.get()
            );
          },
          (error) => {
            console.log(error);
          }
        );
    },
    listMessages() {
      window.gapi.client.gmail.users.messages
        .list({
          userId: "me",
        })
        .then(function (response) {
          console.log(response.result);
        });
    },
    unreadMail() {
      window.gapi.client.gmail.users.labels
        .list({
          userId: "me",
        })
        .then(function (response) {
          console.log(response.result);
        });
    },
    nav(path) {
      this.$router.push({ name: path });
    },
    showCard(item) {
      this.selectedItem = 4;
      this.overlay = true;
      this.productDetails = false;
      for (var key in this.activeDetails) {
        // skip loop if the property is from prototype
        if (!this.activeDetails.hasOwnProperty(key)) continue;
        if (key === item) {
          this.title = item;
          this.activeDetails[key] = true;
          console.log(key + " is true");
        } else {
          this.activeDetails[key] = false;
          console.log(key + " is false");
        }
      }
    },
    getEvents() {
      window.gapi.client.calendar.events
        .list({
          calendarId: "primary",
          timeMin: new Date(2019, 1, 1).toISOString(),
          timeMax: new Date().toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: "startTime",
        })
        .then((response) => {
          this.items = response.result.items;
          console.log(this.items);
        });
    },

    countDown(time, update, complete) {
      var start = new Date().getTime();
      let self = this;
      self.interval = setInterval(function () {
        var now = time - (new Date().getTime() - start);
        if (now <= 0) {
          clearInterval(self.interval);
          complete();
        } else update(Math.floor(now / 1000));
      }, 100); // the smaller this number, the more accurate the timer will be
    },
    convertTime(sec, delayed) {
      let hours = Math.floor(sec / 3600);
      hours >= 1 ? (sec = sec - hours * 3600) : (hours = "00");
      let min = Math.floor(sec / 60);
      min >= 1 ? (sec = sec - min * 60) : (min = "00");
      sec < 1 ? (sec = "00") : void 0;
      min.toString().length == 1 ? (min = "0" + min) : void 0;
      sec.toString().length == 1 ? (sec = "0" + sec) : void 0;
      if (document.getElementById("timer")) {
        document.getElementById("timer").innerHTML =
          `<span style="color:${delayed == "delayed" ? "red;" : "#44da91;"}">` +
          hours +
          ":" +
          min +
          ":" +
          sec +
          " <strong >" +
          delayed +
          " <strong> </span>";
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  },
  mounted() {
    if (!localStorage.currentUser) {
      this.readOutLoud(`Please Confirm you authentication first`);
      this.$router.push({ name: "login" });
    }
    this.userInfo = JSON.parse(localStorage.getItem("currentUser"));

    let self = this;
    this.countDown(
      30000, // milliseconds
      (timeleft) => {
        self.convertTime(timeleft, "remaining"); // If time is remaining
      },
      () => {
        self.readOutLoud(
          `You have four pending decision's to make, should we get them done?`
        );
        let i = 0;
        setInterval(() => {
          i = ++i;
          self.convertTime(i, "delayed"); // Time is delayed
        }, 1000);
      },
      2000
    );

    var myDate = new Date();
    var hrs = myDate.getHours();
    var greet;
    if (hrs < 12)
      greet = "Rendering Cell Funds Business Intelligence Dashboard";
    else if (hrs >= 12 && hrs <= 17)
      greet = "Rendering Cell Funds Business Intelligence Dashboard";
    else if (hrs >= 17 && hrs <= 24)
      greet = "Rendering Cell Funds Business Intelligence Dashboard";
    greet = "";
    this.readOutLoud(`${greet}`);

    window.gapi.load("client:auth2", this.initClient);

    Event.$on("command", (data) => {
      if (!data) return;
      this.overlay = true;
      this.productDetails = false;

      if (
        data.msg.indexOf("emails") !== -1 ||
        data.msg.indexOf("email") !== -1 ||
        data.msg.indexOf("mails") !== -1
      ) {
        this.showCard("Email");

        return;
      } else if (
        data.msg.indexOf("task") !== -1 ||
        data.msg.indexOf("tasks") !== -1
      ) {
        this.showCard("Task");
        return;
      } else if (
        data.msg.indexOf("events") !== -1 ||
        data.msg.indexOf("event") !== -1
      ) {
        this.showCard("Events");
        return;
      } else if (
        data.msg.indexOf("setting") !== -1 ||
        data.msg.indexOf("settings") !== -1
      ) {
        this.showCard("Settings");
        return;
      } else if (data.msg.indexOf("report") !== -1) {
        this.showCard("Report");
        return;
      } else if (data.msg.indexOf("reports") !== -1) {
        this.showCard("Report");
        return;
      } else if (
        data.msg.indexOf("appointment") !== -1 ||
        data.msg.indexOf("appointments") !== -1
      ) {
        this.showCard("AppointmentCalendar");
        return;
      } else if (
        data.msg.indexOf("agenda") !== -1 ||
        data.msg.indexOf("today's agenda") !== -1
      ) {
        this.showCard("Agenda");
        return;
      } else if (data.msg.indexOf("calendar") !== -1) {
        this.showCard("Calendar");
        return;
      } else if (
        data.msg.indexOf("google maps") !== -1 ||
        data.msg.indexOf("directions") !== -1
      ) {
        this.showCard("Map");
        return;
      } else if (
        data.msg.indexOf("videocall") !== -1 ||
        data.msg.indexOf("videocalls") !== -1
      ) {
        this.showCard("VideoCalls");
        return;
      } else if (
        data.msg.indexOf("mix 1") !== -1 ||
        data.msg.indexOf("play mix 1") !== -1
      ) {
        this.showCard("VideoPlayer");
        return;
      } else if (
        data.msg.indexOf("mix 2") !== -1 ||
        data.msg.indexOf("play mix 2") !== -1
      ) {
        this.showCard("VideoPlayer2");
        return;
      } else if (
        data.msg.indexOf("mix 3") !== -1 ||
        data.msg.indexOf("play mix 3") !== -1
      ) {
        this.showCard("VideoPlayer3");
        return;
      } else if (
        data.msg.indexOf("mix 4") !== -1 ||
        data.msg.indexOf("play mix 4") !== -1
      ) {
        this.showCard("VideoPlayer4");
        return;
      } else if (
        data.msg.indexOf("chatroom") !== -1 ||
        data.msg.indexOf("chat") !== -1
      ) {
        this.showCard("Chat");
        return;
      }
    });
    Event.$on("showProductDetails", () => {
      console.log("Show Product");
      this.overlay = true;
      this.productDetails = true;
    });
    Event.$on("weatherReport", (data) => {
      if (
        (data.msg && data.msg.indexOf("weather") !== -1) ||
        (data.msg && data.msg.indexOf("climate") !== -1)
      ) {
        this.showCard("Weather");
        return;
      }
    });
  },
};
</script>


<style scoped>
.flexbox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 428px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
}

.flexbox .board {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 100%;
  background-color: transparent;
  padding: 0px;
}

.flexbox .board .card {
  padding: 5px;
  background: rgba(48, 64, 87, 0.3);
  outline-color: #42da91;
  color: #fff;
  min-width: 390px;
  max-width: 390px;
  cursor: pointer;
}
.html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #222;
  font-size: 0;
}
.svg {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: absolute;
}
.h1 {
  width: 100%;
  font-family: sans-serif;
  position: absolute;
  text-align: center;
  color: white;
  font-size: 18px;
  top: 40%;
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}

.h1 a {
  color: #48b1f4;
  text-decoration: none;
}

.path {
  stroke-linecap: square;
  stroke: white;
  stroke-width: 0.5px;
}

.card {
  height: 100%;
  width: 500px;
  position: relative;
}

.space {
  height: 20px;
}

.theme-icons {
  background: #304057;
  color: #fff;
  size: 100px;
}

.theme-icons:hover {
  background: #304057;
  color: #fff;
}

.theme-bg {
  background: rgba(48, 64, 87, , 0.3);
  color: #fff;
}

.theme-bg-card {
  background: rgba(48, 64, 87, 0.1);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card:hover {
  background: rgba(48, 64, 87, 0.5);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 5px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-2 {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-2:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(0, 255, 0, 0.1),
    0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-warning {
  background: rgba(255, 255, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-warning:hover {
  background: rgba(255, 255, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(0, 255, 0, 0.1),
    0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #ff0000;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.2), inset 0 0 5px rgba(255, 0, 0, 0.1),
    0 2px 0 #000;
  color: #efe;
  outline: none;
}

.theme-bg-card-lg {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}

.theme-bg-card-lg:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1000ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 7px rgba(0, 255, 0, 0.2), inset 0 0 7px rgba(0, 255, 0, 0.1),
    0 2px 0 #000;
  outline: none;
}

@keyframes glow {
  0% {
    border-color: #393;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2),
      inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78b59c;
    box-shadow: 0 0 8px rgba(0, 255, 0, 0.8),
      inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}

.space1 {
  height: 35px;
}

.space2 {
  height: 15px;
}

.space3 {
  height: 1px;
}

.space4 {
  height: 1px;
}

.tabbar {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  & > li {
    margin: 0 11px;
    & > svg {
      width: 14px;
      height: 14px;
      display: block;
      fill: #2f3545;
      transition: opacity 0.3s ease;
    }
  }
  &.open {
    & > li {
      & > svg {
        opacity: 0.5;
      }
    }
  }
}

.Center & dribbble body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  background: #171c28;
  display: flex;
  justify-content: center;
  align-items: center;
  .dribbble {
    position: fixed;
    display: block;
    right: 20px;
    bottom: 20px;
    img {
      display: block;
      height: 28px;
    }
  }
}

.text-color-2 {
  color: #42da91 !important;
}

.user-ui {
  background: rgba(48, 64, 87, 1);
  opacity: 1;
  color: #fff;
  padding: 20px;
}

.theme-bg-2 {
  background: rgba(48, 64, 87, 0.3);
  color: #fff;
}
.menu-icon {
  background: rgba(48, 64, 87, 0.3);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.menu-icon:hover {
  background: rgba(48, 64, 87, 0.5);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}
.detail-card {
  width: 800px;
  height: 400px;
  background: #304057;
  opacity: 0.75;
  position: absolute;
}
.db-content {
  background: linear-gradient(-45deg, #0f1724, #151f2f, #19253a, #304057);
  background-size: 400% 400%;
  min-height: 95vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.product-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.info-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .db-content {
    height: 100%;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
  .callouts {
    padding: 100px;
    border: outline;
    background: #304057;
    opacity: 0.9;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
    outline-color: #5a80bf;
    outline-style: solid;
    animation: glow 1800ms ease-out infinite alternate;
    border-color: #5a80bf;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
      inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
    outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
  .callouts:hover {
    padding: 30px;
    border: outline;
    background: #304057;
    opacity: 1;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
  }
}
</style>
